module.exports = __webpack_public_path__ + "img/domain.37c6e2c7.svg";